<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tVem7j/tc-custom/9780718097240.jpg?1740451937768" alt="This image is the cover for the book Red Letter Words of Jesus"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Red Letter Words of Jesus
      </h1>
      <p class="bookDescription body article font2">
        <p>The words of Jesus—red letter words—are the most important and life changing ever spoken.</p><p>Discover the things Jesus thought were most important.</p><p>What He says about how to live.</p><p>His relationship with God and the Holy Spirit.</p><p>And His overwhelming love for you.</p><p>More than 115 passages from the Bible are considered with illuminating explanation and background facts. Most of all, discovering Jesus’ words will breathe life into your relationship with Him and help you draw close to the One who knows you fully and loves you completely.</p><p><i>The Red Letter Words of Jesus</i>, a classic gift book by bestselling author Jack Countryman, will encourage you in your faith journey, whether you are seeking Christ for the first time or have been following Him for decades.</p><p>With Jesus’ words on one beautiful, highly designed page, and an informative explanation on the facing page, <i>The Red Letter Words of Jesus </i>will bring to life the teachings of Jesus in a new way.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jack Countryman
      </h2>
      
      <p class="authorDescription body article"><P>Jack Countryman is the founder of JCountryman gift books, a division of Thomas Nelson, and is the recipient of the Evangelical Christian Publishers Association's Kip Jordan Lifetime Achievement Award. Over the past 30 years, he has developed bestselling gift books such as<I> God's Promises for Your Every Need</I>,<I> God's Promises for Men</I>,<I> God's Promises for Women</I>,<I> God Listens</I>, and <I>Red Letter Words of Jesus</I>. Countryman's books have sold more than 27 million units. His graduation books alone have sold nearly 2 million units.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1b74c762